<script lang="ts" setup>
import Toast from 'primevue/toast';
import { AppConfirmDialog } from '~/components/base';
</script>

<template>
  <div class="empty-layout page-size relative h-screen w-full">
    <div class="empty-layout__content h-full w-full">
      <NuxtPage :page-key="(route) => route.fullPath" />
    </div>

    <Toast />
    <AppConfirmDialog />
  </div>
</template>

<style lang="scss" scoped>
.empty-layout {
}
</style>
